import { EnrollmentsList } from "@/components/account/EnrollmentsList";

export function DashboardPage() {
  return (
    <div className="space-y-5 sm:space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">Overview</h1>
        <p className="mt-1 text-sm text-muted-foreground sm:text-base">
          What's in your account right now.
        </p>
      </div>

      <div>
        <h2 className="font-display text-lg font-semibold sm:text-xl">Your plans</h2>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Each plan and the domains you've added to it — click a plan to open it.
        </p>
        <div className="mt-3">
          <EnrollmentsList />
        </div>
      </div>
    </div>
  );
}
